// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailTabs-module__container--1gJaN","selected":"DetailTabs-module__selected--Z9p1u","tab":"DetailTabs-module__tab--Ru8M8"};